/**
 * Builds a video URL for a given camera and type.
 * @returns A constructor function for building a video URL.
 */

export function createVideoUrlBuilder(baseUrl: string | undefined) {
  if (!baseUrl) throw new Error('Base URL is required');

  let cameraId: string | null = null;
  const url = new URL(baseUrl);

  const getVideoUrl = () => {
    url.pathname = `/stream/v2/camera/${cameraId}/presign`;
    return url;
  };

  const self = {
    setCameraId: (id: string | null) => {
      cameraId = id;
      return self;
    },

    setFromTime: (fromTime: string) => {
      url.searchParams.set('from_time', fromTime);
      return self;
    },

    setToTime: (toTime: string) => {
      url.searchParams.set('to_time', toTime);
      return self;
    },

    setAlignSegment: (alignSegment: boolean | undefined) => {
      if (alignSegment === undefined) return self;

      url.searchParams.set('align_segment', alignSegment.toString());
      return self;
    },

    setTimeshift: (timeshift: number | undefined) => {
      url.searchParams.set('timeshift', timeshift?.toString() || '0');
      return self;
    },

    build: () => {
      return getVideoUrl().href;
    },
  };

  return self;
}
